// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1OjrJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__1mP7d"};